module.exports = __webpack_public_path__ + "img/bateria.746410ab.jpg";